import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Button,
  Container,
  Typography,
  useTheme,
  useMediaQuery,
  makeStyles
} from '@material-ui/core';
import Page from 'src/components/Page';
import Logo from 'src/components/Logo';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(3),
    paddingTop: 80,
    paddingBottom: 80
  },
  image: {
    maxWidth: '100%',
    width: 560,
    maxHeight: 300,
    height: 'auto'
  }
}));

const NotFoundView = () => {
  const classes = useStyles();
  const theme = useTheme();
  const mobileDevice = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Page
      className={classes.root}
      title="Página não encontrada"
    >
      <Container maxWidth="lg">
        <Box
          p={6}
          display="flex"
          justifyContent="center"
        >
          <Logo type="vertical" />
        </Box>
        <Typography
          align="center"
          variant={mobileDevice ? 'h5' : 'h2'}
          color="textPrimary"
        >
          <Typography
            align="center"
            variant={mobileDevice ? 'h2' : 'h1'}
            color="textPrimary"
          >
            Ooooops, 
          </Typography>
          essa página não existe
        </Typography>
        <Typography
          align="center"
          variant="subtitle2"
          color="textSecondary"
        >
          Ou você tentou alguma rota obscura ou você
          veio aqui por engano. Seja o que for, tente usar a navegação.
        </Typography>
        {/* <Box
          mt={6}
          display="flex"
          justifyContent="center"
        >
          <img
            alt="Em desenvolvimento"
            className={classes.image}
            src="/static/images/undraw_page_not_found_su7k.svg"
          />
        </Box> */}
        <Box
          mt={6}
          display="flex"
          justifyContent="center"
        >
          <Button
            color="secondary"
            component={RouterLink}
            to="/"
            variant="outlined"
          >
            Voltar para home
          </Button>
        </Box>
      </Container>
    </Page>
  );
};

export default NotFoundView;
